import { formatTime } from "lib/format-time"
import { frequencyCode } from "routes/schedule/tasks/frequency-override"

/**
 * The text beside a task's criticality icon in the schedule drawer: frequency (SFG20
 * code, e.g. "6M") and duration per visit for one asset, formatted as elsewhere in the app.
 *
 * @param {{ frequency?: { interval: number, period: string }, minutes?: number }} task
 * @returns {string}
 */
export function describeTaskTiming(task) {
    const timing = []
    if (task.frequency?.period) timing.push(frequencyCode(task.frequency.interval, task.frequency.period))
    timing.push(formatTime(task.minutes || 0))
    return timing.join(" · ")
}
